import { Box, Typography, Grid, useMediaQuery, useTheme } from '@mui/material';
import SliderInfluencersImage1 from '../../assets/sliderInfluencers/sliderInfluencersImage1.png';
import SliderInfluencersImage2 from '../../assets/sliderInfluencers/sliderInfluencersImage2.png';
import SliderInfluencersImage3 from '../../assets/sliderInfluencers/sliderInfluencersImage3.png';
import SliderInfluencersImage4 from '../../assets/sliderInfluencers/sliderInfluencersImage4.png';
import SliderInfluencersImage5 from '../../assets/sliderInfluencers/sliderInfluencersImage5.png';
import SliderInfluencersImage6 from '../../assets/sliderInfluencers/sliderInfluencersImage6.png';
import MegaphoneIcon from '../../assets/sliderInfluencers/megaphone.svg';
import DollorCoinIcon from '../../assets/icons/Dollar.svg';
import Shild from '../../assets/icons/shild.svg';
import Profile from '../../assets/icons/Profile.svg';
import MarketingPlatformCard from '../components/MarketingPlatformCard';
import FairExText from '../../assets/textImage/fairex-text.svg';
import SLPInfluencersListPersonaBtn from '../SLPInfluencers/SLPInfluencersListPersonaBtn';

const LPSectionInfluencers: React.FC = () => {
  const theme = useTheme();
  const isMdOrBelow = useMediaQuery(theme.breakpoints.down('md'));
  
  const rightsOwnerSectionContent = {
    title: 'Influencers',
    subtitle: 'Your Persona. Your Rules. Your Earnings.',
    description: (
      <>
        Saagas is founded with the belief that the work of influencers and other rights holders should never be used without their{' '}
        <strong>consent</strong> and <strong>fair compensation. </strong>
        <Box
          component="img"
          src={FairExText}
          alt="FairEx"
          sx={{
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '1.2em',
            mr: '4px',
            mb: '4px'
          }}
        />{' '}
        empowers them to <strong>monetize</strong> their likeness while ensuring that they remain in <strong>control</strong> of how it is used,
        priced and credited.{' '}
      </>
    )
  };

  const marketingPlatformDataArray = [
    {
      id: 'influencers',
      backgroundImage: [SliderInfluencersImage1, SliderInfluencersImage2, SliderInfluencersImage3, SliderInfluencersImage4, SliderInfluencersImage5, SliderInfluencersImage6],
      title: 'Influencers - Monetize your likeness while retaining control',
      description: (
        <>
          Use{' '}
          <Box
            component="img"
            src={FairExText}
            alt="FairEx"
            sx={{
              display: 'inline-block',
              verticalAlign: 'middle',
              height: '1.2em',
              mr: '4px',
              mb: '4px'
            }}
          />{' '}
          to create a new revenue stream by reaching a wider audience and new brands while ensuring authorized use of your name, image, likeness and voice
          rights.
        </>
      ),
      icon: MegaphoneIcon,
      badges: [
        { id: 1, icon: DollorCoinIcon, text: 'Monetization' },
        { id: 2, icon: Shild, text: 'Full Control' },
        { id: 3, icon: Profile, text: 'Credit' },
        { id: 4, icon: Profile, text: 'Personal branding' }
      ]
    },    
  ];

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        mt: 2,
        pt: 10,
        pb: 10,
        [theme.breakpoints.down('md')]: {
          mt: 0,
          pt: 10
        }
      }}
    >
      <Box textAlign="center" mb={5} sx={{ width: '100%', maxWidth: 1200 }}>
        <Typography
          variant="h4"
          fontFamily="Inter"
          sx={{
            fontWeight: 700,
            fontSize: '41.8px',
            lineHeight: 1,
            color: '#FFFFF !important',
            mb: 4,
            [theme.breakpoints.down('md')]: {
              fontSize: '29px'
            }
          }}
        >
          {rightsOwnerSectionContent.title}
        </Typography>
        <Typography
          fontFamily="Inter"
          sx={{
            width: '100%',
            fontWeight: 600,
            fontSize: '29.03px',
            lineHeight: '120%',
            letterSpacing: '0px',
            textAlign: 'center',
            color: '#FFFF',
            mx: 'auto',
            mb: 3,
            mt: 8,
            padding: '0 20px',
            fontFamily: 'Inter',
            [theme.breakpoints.down('md')]: {
              fontSize: '16px',
              fontWeight: 300,
              mx: 'none',
              mb: 2,
              mt: 3
            }
          }}
        >
          {rightsOwnerSectionContent.subtitle}
        </Typography>
        <Typography
          fontFamily="Inter"
          sx={{
            width: '100%',
            fontWeight: 300,
            fontSize: '20px',
            lineHeight: '120%',
            letterSpacing: '0px',
            textAlign: 'center',
            color: '#C0C0C0',
            mx: 'auto',
            padding: '0 20px',
            fontFamily: 'Inter',
            [theme.breakpoints.down('md')]: {
              fontSize: '16px',
              fontWeight: 300,
              color: '#FFFFFF'
            }
          }}
        >
          {rightsOwnerSectionContent.description}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '7rem',
          width: '100%',
          maxWidth: 1280,
          mb: 7,
          [theme.breakpoints.down('md')]: {
            gap: '2rem',
            mb: 0
          }
        }}
      >
        {marketingPlatformDataArray.map((data, index) => (
          <Grid item key={index} id={data.id}>
            <MarketingPlatformCard marketingPlatformData={data} />
          </Grid>
        ))}
      </Box>
      <Box
        sx={{
          mt: 0,
          [theme.breakpoints.down('md')]: {
            mt: 0
          }
        }}
      >
        <SLPInfluencersListPersonaBtn
          maxWidth={isMdOrBelow ? '131px' : '200px'}
          maxHeight={isMdOrBelow ? '49px' : '52px'}
          fontSize={isMdOrBelow ? '14px' : '16px'}
          padding={isMdOrBelow ? '8px 15px' : '16px 32px'}
        />
      </Box>
    </Box>
  );
};

export default LPSectionInfluencers;
